import React from 'react';
import { HeaderNav, MainFooter } from '../components';

export const MainLayout = (props) => {
  const { children } = props;

  return (
    <div className='main-layout'>
      <section className='header__box'>
        <HeaderNav></HeaderNav>
      </section>
      <section className='content__box'>{children}</section>
      <section className='footer__box'>
        <MainFooter></MainFooter>
      </section>
    </div>
  );
};
